import { guideDemo } from './index';
import { Stage } from './stage';

/**
 * A tool guide as a card: the name, the ⌃ that brings it back, the picture, the line.
 * The same card whether Control called it up, a long hover on a tool's button did, or the
 * tool was picked for the first time.
 */
export function GuideCard({ guide, name, line }: { guide: string; name: string; line: string }) {
  const Demo = guideDemo(guide);
  return <>
    <div className="tool-cursor-guide-heading"><strong>{name}</strong><kbd aria-label="Hold Control to see this again">⌃</kbd></div>
    {Demo ? <Stage label={name}><Demo key={guide} /></Stage> : null}
    <p>{line}</p>
  </>;
}
